import { render, staticRenderFns } from "./EntityOverviewWidget.vue?vue&type=template&id=df40e706"
import script from "./EntityOverviewWidget.vue?vue&type=script&lang=js"
export * from "./EntityOverviewWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports